var _path, _rect;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThumbsUp = function SvgThumbsUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "md-thumbs-up",
    width: 40.074,
    height: 37.001,
    viewBox: "0 0 40.074 37.001",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_70665",
    "data-name": "Path 70665",
    d: "M163.662,101h16.573a3.535,3.535,0,0,0,3.3-2.255l5.5-13.047a3.688,3.688,0,0,0,.251-1.349V80.631c0-2.033-1.638-4.3-3.642-4.3H174.155l1.734-7.853.058-.578a2.793,2.793,0,0,0-.8-1.956L173.2,64,161.06,76.266A3.709,3.709,0,0,0,160,78.877v18.5A3.633,3.633,0,0,0,163.662,101Z",
    transform: "translate(-149.208 -64)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10986",
    "data-name": "Rectangle 10986",
    width: 5.343,
    height: 21.373,
    transform: "translate(0 15.49)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThumbsUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumbs-up.228d92e8.svg";
export { ForwardRef as ReactComponent };